<template>
    <font-awesome-icon
        v-if="airbnbStatus.status === 'NOT_CREATED'"
        class="text-warning"
        :icon="['fas', 'spinner']"
    />
    <font-awesome-icon
        v-else-if="
            airbnbStatus.status === 'REJECTED' ||
            hasSyncError ||
            airbnbQualityStandardStatus === PARTNER_AIRBNB_QUALITY_STANDARD_STATUS_SUSPEND
        "
        class="text-danger"
        :icon="['fas', 'circle-exclamation']"
    />
    <font-awesome-icon
        v-else-if="airbnbQualityStandardStatus === PARTNER_AIRBNB_QUALITY_STANDARD_STATUS_WARN"
        class="text-warning"
        :icon="['fas', 'circle-question']"
    />
    <font-awesome-icon
        v-else
        class="text-success"
        :icon="['fas', 'check']"
    />
</template>

<script>
import {
    PARTNER_AIRBNB_QUALITY_STANDARD_STATUS_WARN,
    PARTNER_AIRBNB_QUALITY_STANDARD_STATUS_SUSPEND,
} from '../../../constants';

export default {
    data() {
        return {
            airbnbStatus: {},
            hasSyncError: false,
            airbnbQualityStandard: null,
            PARTNER_AIRBNB_QUALITY_STANDARD_STATUS_WARN,
            PARTNER_AIRBNB_QUALITY_STANDARD_STATUS_SUSPEND,
        };
    },
    created() {
        this.airbnbStatus = this.params.data && this.params.data.airbnb_status;
        this.hasSyncError =
            this.params.data && this.params.data.has_sync_error;
        this.airbnbQualityStandard = this.params.data.airbnb_quality_standard;
    },
    computed: {
        airbnbQualityStandardStatus() {
            return this.airbnbQualityStandard ? this.airbnbQualityStandard.status : null;
        }
    },
};
</script>